import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PUT_AWAY_STATUSES } from 'domains/seller-inventory-batch/constants'

const propTypes = {
  put_away_status: PropTypes.string
}

/**
 * To give nice look on Seller Inventory Batch `put_away_status`.
 * It maps `put_away_status` to certain style and pass to `StatusBadge`.
 * @param {string} put_away_status Seller Inbound Inventory Batch Items. available values
 * - `pending`
 * - `complete`
 */
const PutAwayStatusBadge = ({ put_away_status }) => {

  const colorMap = {
    [PUT_AWAY_STATUSES.PENDING]  : 'warning',
    [PUT_AWAY_STATUSES.COMPLETE] : 'success'
  }

  const color = colorMap[put_away_status]

  return <StatusBadge color={ color } label={ put_away_status } />
}

PutAwayStatusBadge.propTypes = propTypes

export default PutAwayStatusBadge
